<template>
  <div class="row">
    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="title">Title <star></star></label>
      <b-form-group id="title" label-for="title">
        <multiselect class="mt-1 field-container" v-model="form.title" :options="title_options"></multiselect>
      </b-form-group>
    </div>
    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="first_name">First Name <star></star></label>
      <b-form-group id="first_name" label-for="first_name">
        <b-form-input class="mt-1 field-container fields" type="text" placeholder="Enter First Name"
          v-model="form.first_name"></b-form-input>
        <errors v-if="form.errors.first_name">
          {{ form.errors.first_name[0] }}
        </errors>
      </b-form-group>
    </div>
    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="middlename">Middle Name</label>
      <b-form-group id="middlename" label-for="middlename">
        <b-form-input class="mt-1 field-container fields" type="text" placeholder="Enter Middle Name"
          v-model="form.middlename"></b-form-input>
        <errors v-if="form.errors.middlename">
          {{ form.errors.middlename[0] }}
        </errors>
      </b-form-group>
    </div>
    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="last_name">Surname <star></star></label>
      <b-form-group id="last_name" label-for="last_name">
        <b-form-input class="mt-1 field-container fields" type="text" placeholder="Enter Surname"
          v-model="form.last_name"></b-form-input>
        <errors v-if="form.errors.last_name">
          {{ form.errors.last_name[0] }}
        </errors>
      </b-form-group>
    </div>
    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="gender">Gender <star></star></label>
      <b-form-group id="first_name" label-for="first_name">
        <multiselect class="mt-1 field-container" v-model="form.gender" :options="gender_options"></multiselect>
        <errors v-if="form.errors.gender">
          {{ form.errors.gender[0] }}
        </errors>
      </b-form-group>
    </div>

    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="dob">Date of Birth <star></star></label>
      <b-form-group id="dob" label-for="dob">
        <b-form-input class="mt-1 field-container fields" type="date" v-model="form.date_of_birth"></b-form-input>
        <errors v-if="form.errors.date_of_birth">
          {{ form.errors.date_of_birth[0] }}
        </errors>
      </b-form-group>
    </div>

    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="marital_status">Marital Status <star></star></label>
      <b-form-group id="marital_status" label-for="marital_status">
        <multiselect class="mt-1 field-container" v-model="form.marital_status" :options="marital_options">
        </multiselect>
        <errors v-if="form.errors.marital_status">
          {{ form.errors.marital_status[0] }}
        </errors>
      </b-form-group>
    </div>


    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="email">Email</label>
      <b-form-group id="email" label-for="email">
        <b-form-input class="mt-1 field-container fields" type="email" placeholder="Enter Email Address"
          v-model="form.email"></b-form-input>
        <errors v-if="form.errors.email">
          {{ form.errors.email[0] }}
        </errors>
      </b-form-group>
    </div>

    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="phone">Phone Number<star></star></label>
      <b-form-group id="phone" label-for="phone">
        <b-form-input class="mt-1 field-container fields" type="number"
          placeholder="Enter Phone Number Eg. 0244411100" v-model="form.mobile"></b-form-input>
        <errors v-if="form.errors.mobile">
          {{ form.errors.mobile[0] }}
        </errors>
      </b-form-group>
    </div>


    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="mobile_secondary">Secondary Phone Number</label>
      <b-form-group id="mobile_secondary" label-for="mobile_secondary">
        <b-form-input class="mt-1 field-container fields" type="number"
          placeholder="Enter Phone Number Eg. 0244411100" v-model="form.mobile_secondary"></b-form-input>
        <errors v-if="form.errors.mobile">
          {{ form.errors.mobile[0] }}
        </errors>
      </b-form-group>
    </div>

    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="phone">Old Code</label>
      <b-form-group id="phone" label-for="phone">
        <b-form-input class="mt-1 field-container fields" type="text" placeholder="Enter Old Code"
          v-model="form.external_code"></b-form-input>
        <errors v-if="form.errors.external_code">
          {{ form.errors.external_code[0] }}
        </errors>
      </b-form-group>
    </div>

    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="unapproved_withdrawal_max_amount">Withdraw max threshold</label>
      <b-form-group id="unapproved_withdrawal_max_amount" label-for="unapproved_withdrawal_max_amount">
        <b-form-input class="mt-1 field-container fields" type="number" placeholder="Enter Withdraw max threshold"
          v-model="form.unapproved_withdrawal_max_amount"></b-form-input>
        <errors v-if="form.errors.unapproved_withdrawal_max_amount">
          {{ form.errors.unapproved_withdrawal_max_amount[0] }}
        </errors>
      </b-form-group>
    </div>

    <div class="col-12 col-md-6 mb-2">
      <label class="akkurate-dark small" for="ghana-card">Ghana Card Number</label>
      <b-form-group id="ghana-card" label-for="ghana-card">
        <b-form-input class="mt-1 field-container fields" type="text" placeholder="Enter Ghana Card"
          v-model="form.ghana_card_number"></b-form-input>
        <errors v-if="form.errors.ghana_card_number">
          {{ form.errors.ghana_card_number[0] }}
        </errors>
      </b-form-group>
    </div>

    <div class="col-12 col-md-3 mb-2">
      <label class="akkurate-dark small" for="ro">Ro <star></star></label>
      <b-form-group id="ro" label-for="ro">
        <multiselect class="field-container mt-1 " v-model="form.ro" selectLabel="" :custom-label="customLabel"
          deselectLabel="" :options="users_option"></multiselect>
        <errors v-if="form.errors.ro">
          {{ form.errors.ro[0] }}
        </errors>
      </b-form-group>
    </div>

    <div class="col-12 col-md-3 mb-2">
      <label class="akkurate-dark small" for="status">Status <star></star></label>
      <b-form-group id="status" label-for="status">
        <multiselect class="field-container mt-1" :disabled="add_or_edit == 'add'" v-model="form.status"
          selectLabel="" deselectLabel="" :options="status_options"></multiselect>
        <errors v-if="form.errors.status">
          {{ form.errors.status[0] }}
        </errors>
      </b-form-group>
    </div>

  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import ApiService from "@/core/services/api.service";
import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
export default {
  name: "PersonalDetails",
  props: ['form', 'roles', 'add_or_edit', 'users_option'],
  components: {
    Multiselect,
    vueDropzone,
  },
  data() {
    return {
      title: '',
      title_options: ['Mr', 'Mrs', 'Miss', 'Master', 'Dr', 'Prof'],
      gender_value: '',
      external_code: '',
      gender_options: ['Male', 'Female'],
      marital_value: '',
      marital_options: ['Single', 'Married', 'Divorced', 'Widow'],
      status: '',
      status_options: ['Pending', 'Active', 'Inactive', 'Dormant', 'Closed'],
      // customer_types: ['INDIVIDUAL', 'GROUP', 'CORPORATE', "IN_TRUST"],
      // mandates: ["ONLY_PRINCIPAL_SIGNATORY", "PRINCIPAL_SIGNATORY_AND_ANY_OTHER_ONE",
      //   "ANY_OTHER_TWO_OF_THE_SIGNATORIES"],
      selectedFrontFile: null,
      selectedPassportPicFile: null,
      previewFrontUrl: null,
      frontCardName: "",
      selectedBackFile: null,
      selectedSignatureFile: null,
      previewBackUrl: null,
      backCardName: "",
      signatureCardName: "",
      selectedSignFile: null,
      previewSignUrl: null,
      signatureName: "",
      front_upload: "Click To Upload",
      back_upload: "Click To Upload",
      signature_upload: "Click To Upload",
      front_upload_processing: false,
      front_spin_visible: false,
      front_success_visible: false,
      front_text_visible: false,
      back_upload_processing: false,
      signature_upload_processing: false,
      back_spin_visible: false,
      signature_spin_visible: false,
      back_success_visible: false,
      back_text_visible: false,
      signature_success_visible: false,
      signature_text_visible: false,
      passport_pic_card: null,
      passportpic_upload: "Click To Upload",
      passportpic_spin_visible: false,
      passportpic_text_visible: false,
      passportpic_upload_processing: false,
      previewPassportUrl: null,
      passportpic_success_visible: false,
      previewPassportPicUrl: null,
      previewSignatureUrl: null,
      signature_card: null,
      back_ghana_card: null,
    }
  },
  methods: {
    customLabel({ id, first_name, surname, roles }) {
      return `${id} ${first_name} ${surname} - (${roles[0]?.display_name ?? "Role Not Found!"})`
    },
  }
}
</script>